import palette from "../../styles/palette";


const styles = {
    listItem: {
        border: "solid 1px lightgray",
        padding: 10,
        borderRadius: 5,
        marginBottom: 5
    } as React.CSSProperties,
    twoFactor: {
        padding: 20,
        marginBottom: 40,
        backgroundColor: "#D6EDDC",
        color: "black",
        borderRadius: 5,
        textAlign: "center",
        cursor: "pointer",
        border: "solid 2px #eee"
    } as React.CSSProperties,
    twoFactorNotProtected: {
        padding: 20,
        marginBottom: 40,
        backgroundColor: palette.active.primary,
        color: "white",
        borderRadius: 5,
        textAlign: "center",
        cursor: "pointer"
    } as React.CSSProperties,
};
export default styles;